import React, {useEffect, useState} from 'react'
import {NavLink, useMatch} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import $ from 'jquery';
import {
  CButton,
  CContainer,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CImage,
  CNavItem,
  CNavLink
} from '@coreui/react'

import {getItem, itemKey} from 'src/libs/preference'
import {nonAuthedReqPost} from 'src/libs/request'
import MaterialFinderModal from "./header/MaterialFinderModal";
import Logo from '../assets/img/img_dalkom_logo.svg';

const AppHeader = () => {
  const isMain = useMatch('/home');

  const dispatch = useDispatch();
  const isMobile = useSelector((state) => state.isMobile);
  const cat_id = useSelector((state) => state.cat_id);
  const cat_id2 = useSelector((state) => state.cat_id2);
  const cat_id3 = useSelector((state) => state.cat_id3);
  const materialFinderOpen = useSelector((state) => state.materialFinderOpen);

  const [showPopover,   setShowPopover] = useState(true);
  const [user_name,     setNickname] = useState('');
  const [catList,       setcatList] = useState([]);
  const [catList2,      setcatList2] = useState([]);
  const [catList3,      setcatList3] = useState([]);

  useEffect( () => {
    const user_name   = getItem(itemKey.user_name);
    setNickname(user_name);
    // 
    init();
  }, []);
  
  const init = () => {
    if(!isMain) {
      nonAuthedReqPost('getCategorys', {}, (res) => {
        if(Boolean(res)) {
          const {catList, catList2, catList3} = res;
          setcatList(catList);
          setcatList2(catList2);
          setcatList3(catList3);
        }
      });
    }

    // 
    $(document).on('mouseover', '.sub-menu li', function(_e) {
      $(this).addClass('on');
    })
  }

  const gotoDetail = (cat_id, cat_id2='', cat_id3='') => {
    dispatch({ type: 'updateCategory', cat_id });
    dispatch({ type: 'updateCategory2', cat_id2 });
    dispatch({ type: 'updateCategory3', cat_id3 });
    // navigate(url, {replace: true});
    window.location.href = `tiles?cid=${cat_id}&cid2=${cat_id2}&cid3=${cat_id3}`;
  }

  return (
    <CHeader position='sticky'>
      {isMobile ?
      <div className='mobile-header'>
        <div className='width6'>
          <CDropdown >
            <CDropdownToggle placement="bottom-end" caret={false} variant={'ghost'}>
              <CImage src='/img/i_three_bar.png' className='w-16px' />
            </CDropdownToggle>
            <CDropdownMenu className={Boolean(user_name) ? 'auth' : 'none-auth'} placement="bottom-end">
              {
                !isMain && catList.map((item, index) =>
                <CDropdownItem key={index} onClick={() => gotoDetail(item.id)} className={`${cat_id == item.id ? 'active' : ''}`} >{item.cat_name}</CDropdownItem>
                )
              }
              {isMain && <CDropdownItem href="/home#story" component={'a'}>스토리</CDropdownItem>}
              {isMain && <CDropdownItem to="/tiles?cid=3&cid2=&cid3=" component={NavLink}>자재구매</CDropdownItem>}
              {isMain && <CDropdownItem href="/home#showroom" component={'a'}>쇼룸안내</CDropdownItem>}
              {isMain && <CDropdownItem href="/home#portfolio" component={'a'}>포트폴리오</CDropdownItem>}
              {!isMain && <CDropdownItem to="/cart" component={NavLink}>장바구니</CDropdownItem>}
              {!isMain && <CDropdownItem to="/wish-list" component={NavLink}>위시리스트</CDropdownItem>}
              {Boolean(user_name) && <CDropdownItem to="/memberinfo" component={NavLink} className="text-white">MY PAGE</CDropdownItem>}
              {Boolean(user_name) || <CDropdownItem to="/register" component={NavLink}>회원가입</CDropdownItem>}
              {Boolean(user_name) || <CDropdownItem to="/login" component={NavLink} className="white-text">로그인</CDropdownItem>}
            </CDropdownMenu>
            <div className='menu-mask' />
          </CDropdown>
        </div>
        <CHeaderBrand href="/">
          <strong><img src={Logo} width={100} height={35} alt="달콤자재창고" /></strong>
        </CHeaderBrand>
        <div className='rigth-wrap'>
          <CButton color="dark"><span onClick={() => dispatch({ type: 'openMaterialFinder' })}>자재파인더</span></CButton>
          {isMain && showPopover && <div className="popover">
            필요한 자재를 AI로 찾아보세요!
            <CButton color="close" onClick={() => setShowPopover(false)}></CButton>
          </div>}
        </div>
        {materialFinderOpen &&
            <MaterialFinderModal
                isMobile={true}
                onSuccess={() => {}}
            />}
      </div>
      :
      <CContainer fluid>
        <CHeaderBrand className="me-auto" href="/">
          <strong><img src={Logo} width={125} height={45} alt="달콤자재창고" /></strong>
        </CHeaderBrand>
        <CHeaderNav className="ms-auto d-none d-md-flex">
          {isMain && <>
          <CNavItem>
            <CNavLink href="/home#story">
              스토리
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="/tiles?cid=3&cid2=&cid3=">
              자재구매
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="/home#showroom">
              쇼룸안내
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="/home#portfolio">
              포트폴리오
            </CNavLink>
          </CNavItem>
          </>}
          {!isMain && catList.map((item, index) =>
            <CNavItem key={index}>
              <CNavLink onClick={() => gotoDetail(item.id)} className={`${cat_id == item.id ? 'active' : ''}`}>{item.cat_name} <span /></CNavLink>
              {catList2.filter(dt => dt.cat_id == item.id).length > 0 &&
              <ul className='sub-menu'>
                <li className='dummy' />
                {
                  catList2.filter(dt => dt.cat_id == item.id).map((item2, index2) =>
                  <li key={index2}>
                    <div onClick={() => gotoDetail(item.id, item2.id)} className={`${cat_id2 == item2.id ? 'active' : ''}`}>{item2.cat_name} </div>
                    <ul className={`sub-sub-menu ps-1 ${catList3.filter(dt => dt.cat_id2 == item2.id).length > 0 ? 'py-2' : ''}`}>
                      {
                        catList3.filter(dt => dt.cat_id2 == item2.id).map((item3, index3) =>
                        <li className={'ellipsis1' + (cat_id3 == item3.id ? ' underline' : '')} onClick={() => gotoDetail(item.id, item2.id, item3.id)} key={index3}>{'• ' + item3.cat_name}</li>
                        )
                      }
                    </ul>
                  </li>
                  )
                }
              </ul>}
            </CNavItem>
            )
          }
          <CNavItem className="material-finder">
            <CButton color="dark"><span onClick={() => dispatch({ type: 'openMaterialFinder' })}>자재파인더</span></CButton>
            {isMain && showPopover && <div className="popover">
              필요한 자재를 AI로 찾아보세요!
              <CButton color="close" onClick={() => setShowPopover(false)} aria-label="닫기"></CButton>
            </div>}
          </CNavItem>
          <CNavItem>
            {Boolean(user_name) ?
            <CNavLink to="/memberinfo" component={NavLink} className='pe-2'>MY PAGE</CNavLink> :
            <CNavLink to="/login" component={NavLink} className='pe-2'>로그인 | 회원가입</CNavLink>}
          </CNavItem>
          <CNavItem className="cart">
            <CNavLink to="/cart" component={NavLink} className='pe-2'><span className="sound-only">장바구니</span></CNavLink>
          </CNavItem>
        </CHeaderNav>
        {materialFinderOpen &&
            <MaterialFinderModal
                isMobile={false}
                onSuccess={() => {}}
            />}
        {/* <CHeaderNav className="ms-3">
          <AppHeaderDropdown />
        </CHeaderNav> */}
      </CContainer>}
    </CHeader>
  )
}

export default AppHeader
